
// Vue
import {Options, Vue} from "vue-class-component";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorNavigationVue from "@/components/administrator/navigation.vue";
import AdministratorResourcesNavigationVue from "@/components/administrator/resources/navigation.vue";
import AppAdministratorResourcesSupplementsListIndexVue from "@/views/app/administrator/resources/supplements/list/index.vue";

@Options({
  components: {
    ElRow,
    ElCol,
    AdministratorNavigationVue,
    AdministratorResourcesNavigationVue,
    AppAdministratorResourcesSupplementsListIndexVue,
  },
})
export default class AppAdministratorResourcesSupplementsIndexVue extends Vue {}
